import configJsonKR from '../config/kr/websdk.json'
// import WebSDK from '@yo-star/websdk'

// console.log('configJsonKR', configJsonKR)
// debugger
const WebSDK = window.WebSDK
let websdkInstance = null

export const initWebSDK = async locale => {
  try {
    if (websdkInstance) {
      return true // 已经初始化过
    }

    const meta = { pid: 'US-AZURLANE', areaServer: 'En', cfg: configJsonKR }

    console.log('websdk locale:', locale, 'meta:', meta)

    // const cfg = await baseConfig()

    // https://webusstatic.yo-star.com/arknights-kr/ark-kr-gs25-h5/test/arkkrgs25h5/_nuxt/block5-board.CdeuF3u8.png
    const instance = new WebSDK(meta.cfg)
    websdkInstance = instance

    const initRes = await instance.Init({
      PID: meta.pid,
      areaServer: meta.areaServer,
    })

    if (initRes.code !== 0) {
      console.error('WebSDK初始化失败: ', initRes.code)
      return false
    }

    return true
  } catch (error) {
    console.error('WebSDK初始化过程中发生错误:', error)
    return false
  }
}

export const getWebSDKInstance = () => {
  return websdkInstance
}

export const login = async (locale, cb) => {
  console.trace('login..')
  localStorage.removeItem('token')
  if (!websdkInstance) {
    await initWebSDK(locale)
  }
  cb && cb()
  return websdkInstance && websdkInstance.Login()
}

export const logout = async locale => {
  localStorage.removeItem('token')
  if (!websdkInstance) {
    await initWebSDK(locale)
  }
  return websdkInstance.Logout()
}

export const cleanupWebSDK = () => {
  websdkInstance = null
}

export default {
  initWebSDK,
  getWebSDKInstance,
  login,
  logout,
  cleanupWebSDK,
}
